import React from "react";
import { useQuery } from "@tanstack/react-query";
import { QUERIES } from "../helpers/consts";
import { getCategorys, getPosts } from "../core/request";
import { Post } from "../core/model";
import { useNavigate } from "react-router-dom";

function Footer() {
	const navigate = useNavigate();
	const { data: homilies } = useQuery({
		queryKey: [QUERIES.POSTS, 'homilies'],
		queryFn: () => {
			return getPosts(
				`&sort_field=id&sort_order=desc&filter={"status":true,"category_slug":["homilies"]}`
			)
		},
	})
	const { data: footer_categories } = useQuery({
		queryKey: [QUERIES.CATEGORIES, 'footer'],
		queryFn: () => {
			return getCategorys(
				`sort_field=order&sort_order=asc&filter={"status":true,"show_on_footer":true}`
			)
		},
	})

	const openSermon = (entity: Post) => {
		return navigate("/details/" + entity.id);
		// Here, you can set the expanded entity or navigate to a new page showing more details
	  };
	
	return (
		<footer>
			<div className='container'>
				<div className='row'>
					<div className='row left'>
						<div className='why'>
							<center>
								<h4>Catholic Diocese of Osogbo</h4>
								<img
									src='/images/coat_of_arm.png'
									alt='image_text'
									height='200px'
								/>
							</center>
						</div>
						<div className='pages'>
							<h4>Pages</h4>
							<ul>
								{footer_categories?.entities?.map((entity) => (
									<li key={entity.id}>
										<a href='#!'>{entity.title}</a>
									</li>
								))}
							</ul>
						</div>
					</div>

					<div className='row right'>
						<div className='contact'>
							<h4>Contact us</h4>
							<p>
								Bishop's House, P.O. Box 78,
								<br />
								Oke-Ayepe, Osogbo,
								<br />
								Osun State, Nigeria
							</p>
							<p>
								Phone: <a href='tel:08105584018'>0(810) 558 4018</a>
								<br />
								Mail:{' '}
								<a href='mailto:contact@catholicdioceseosogbo.org'>
									contact@catholicdioceseosogbo.org
								</a>
							</p>
						</div>
						<div className='recent'>
							<h4>Recent Sermons</h4>
							{homilies?.entities?.map((entity) => (
								<div key={entity.id} className='figure row'>
									<div>
										<img src='/images/footer-img1.jpg' alt='image_text' />
									</div>
									<div className='figcaption'>
										<h5 className='heading'>
										<a href="#!" onClick={() => openSermon(entity)}>
                        {entity.title}
                      </a>
										</h5>
										<h5 className='date'>April 10, 2015</h5>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>

				<h6>
					&copy; {new Date().getFullYear()} Catholic Diocese of Osogbo. Powered
					by{' '}
					<a
						href='https://starlightesolutions.com/'
						target='_blank'
						rel='noreferrer'
					>
						<span>Starlight Inc.</span>
					</a>
				</h6>
			</div>
		</footer>
	)
}

export default Footer
